import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components/macro'
import { theme } from 'styled-tools'
import { MdClose } from 'react-icons/md'
import { media } from 'ui/rwd'
import { CircleIcon as BaseCircleIcon } from 'ui/components/CircleIcons'

const CloseCircle = styled(BaseCircleIcon).attrs({
  width: '2.5rem',
  height: '2.5rem'
})`
  border: 0;
  position: absolute;
  top: 15px;
  left: 15px;
  cursor: pointer;
  z-index: 11;
  background: ${theme('white')};
  color: ${theme('black')};
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
  &:hover {
    background: white;
  }
  ${media.sm`
    left: initial;
    top: -45px;
    right: 0px !important;
  `}
`

const CloseIcon = styled(MdClose)`
  width: 1.5rem;
  color: black;
`

const CloseButton = React.memo(({ toggle, ...props }) => (
  <CloseCircle onClick={toggle} {...props}>
    <CloseIcon />
  </CloseCircle>
))

CloseButton.displayName = 'CloseButton'

CloseButton.propTypes = {
  toggle: PropTypes.func
}

export default CloseButton
